<script>
export default {
  HTTP_SUCCESS: 200,

  //系统开关 0：正常
  SYS_NORMAL_ENABLE: '0',
  //系统开关 1：停用
  SYS_NORMAL_DISABLE: '1',

  SERVER_URL: 'http://www.zggcbaohan.com',
  // SERVER_URL: 'http://127.0.0.1:8081',
};
</script>



// WEBPACK FOOTER //
// src/common/static.vue